// extracted by mini-css-extract-plugin
export var alignBaseline = "_19-9";
export var alignCenter = "_19-5";
export var alignFlexEnd = "_19-7";
export var alignFlexStart = "_19-6";
export var alignSelfBaseline = "_19-e";
export var alignSelfCenter = "_19-a";
export var alignSelfFlexEnd = "_19-c";
export var alignSelfFlexStart = "_19-b";
export var alignSelfStretch = "_19-d";
export var alignStretch = "_19-8";
export var column = "_19-2";
export var columnReverse = "_19-4";
export var flex = "_19-0";
export var justifyCenter = "_19-f";
export var justifyFlexEnd = "_19-h";
export var justifyFlexStart = "_19-g";
export var justifySpaceAround = "_19-j";
export var justifySpaceBetween = "_19-i";
export var justifySpaceEvenly = "_19-k";
export var row = "_19-1";
export var rowReverse = "_19-3";
export var wrapNowrap = "_19-m";
export var wrapWrap = "_19-l";
export var wrapWrapReverse = "_19-n";